<template>
    <div>
            <!--Content Wrap Start-->

    <div class="kode_content" >

    <!--Bread Crumb Wrap Start-->
    <div class="kode_about_bg">
    	<div class="container">
        	<div class="kode_aboutus_wrap">
            	<h4>KEGIATAN</h4>
				<div class="kode_bread_crumb">
                	<ul>
                		<li><a href="/">Home</a></li>
                    	<li><router-link to="/kegiatan">KEGIATAN</router-link></li>
                	</ul>
                </div>
            </div>
        </div>
    </div>
    <!--Bread Crumb Wrap Start-->    
    
        <section>
        	<div class="container" >
            	<div class="row">
                	<!--News Deatail Wrap Start-->
                	<div class="col-md-8">
                    	<div class="kode_news_detail">
                        	<figure>
                            	<img :src="file_path+foto" alt="Image Here" style="display: block;width: 100%;height: 400px">
                            </figure>
                            <h4>{{nama}}</h4>
                            <ul>
                            	<li>by <a href="#"> <span>{{createBy}} </span> </a> <i class="fa fa-calendar"></i>{{convert_tgl(tgl)}}</li>
                                <!-- <li> <a href="#"> <i class="fa fa-heart-o"></i>144 </a> </li>
                                <li> <a href="#"> <i class="fa fa-comment-o"></i>49 </a> </li>
                                <li> <a href="#"> <i class="fa fa-eye"></i>12,998 </a> </li> -->
                            </ul>
                            <p v-html="deskripsi"> </p>
                          
                        </div>
                        
 
						
 
                        
 
                        
 
                        
                    </div>
                    <!--News Deatail Wrap End-->
                    
                    <!--Aside Wrap Start-->
                    <div class="col-md-4">
                    	<!-- <div class="kode_aside_search">
                        	<form>
                            	<input id="search" type="text" placeholder="Search ..." @keyup="cari_data" v-model="cari_value">
                                <button><i class="fa fa-search"></i></button>
                            </form>
                        </div> -->
                        
 
                        
						<!--Aside Event Wrap Start-->
                        <div class="kode_aside_event kode_aside">
                        	<h5>Kegiatan</h5>
                            <ul>
                            	<li v-for="data in kegiatan" :key="data.id">
                                	<figure>
                                    	<img :src="file_path+data.foto" alt="Image Here">
                                        <figcaption>
                                         
                                            <a href="javascript:void(0);" onClick="document.location.reload(true)" @click="push_kegiatan(data.id)"><i class="fa fa-link"></i></a>
                                        </figcaption>
                                    </figure>
                                    <div class="kode_aside_event_des" style="text-align:justify">
                                    	<p v-html="limit_desk_kegiatan(data.deskripsi)+' ...'"> </p>
                                    	<span><b>{{convert_tgl(data.createAt)}}</b></span>
                                    </div>
                                </li>
                                
 
                            </ul>
                        </div>
                        <!--Aside Event Wrap End-->
						
 
                        
 
                        
						<!--Aside Flicker Wrap Start-->
                        <div class="kode_aside_flicker kode_aside">
                        	<h5>Galleri Kegiatan</h5>
                        	<ul>
                            	<li v-for="data in kegiatan6" :key="data.id">
                                	<a href="javascript:void(0);" onClick="document.location.reload(true)" @click="push_kegiatan(data.id)">
                                		<figure>
                                    		<img :src="file_path+data.foto" alt="Image Here" style="height:90px;width:100%">
                                            <figcaption>
                                            	<i class="fa fa-plus"> </i>
                                            </figcaption>
                                    	</figure>
                                	</a>
                                </li>
                                
 
                            </ul>
                        </div>
						<!--Aside Flicker Wrap End-->
                        
                    </div>
                    <!--Aside Wrap End-->
                    
                </div>
            </div>
        </section>
        
    </div>
    <!--Content Wrap End-->
    </div>
</template>



<script>




// const ADD_URL = URL_APP + "api/v1/publish_kegiatan/";

const KEGIATAN_URL = URL_APP + "api/v1/publish_kegiatan/";



const FILE_LOAD = URL_APP+'uploads/';

export default {
  name: "web_pengumuman",
//   title: "My page title",
  data() {
    return {
        id : this.$route.params.id,
        createAt : '',
        createBy : '',
        nama : '',
        deskripsi : '',
        tgl : '',
        foto : '',
    
    kegiatan:[],
    kegiatan6:[],


		
        HOST : URL_HOST+this.$route.fullPath,
        hest : 'http://twitter.com',
		file_path : FILE_LOAD,

    //   list_data: [],
    //   page_first: 1,
    //   page_last: 0,
    //   cari_value: ""
    };
  },

  // =============================================================== METHODS =========================================================================
  methods: {
      

	getView: function() {
      fetch(KEGIATAN_URL + "isi_kegiatan", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          id: this.$route.params.id,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          var kegiatan = res_data[0];
        //   console.log(kegiatan);

            this.createAt = kegiatan.createAt;
            this.createBy = kegiatan.createBy;
            this.nama = kegiatan.nama;
            this.deskripsi = kegiatan.deskripsi;
            this.tgl = kegiatan.tgl; 
            this.foto = kegiatan.foto;    

       });
    },

    getKegiatan: function() {
        fetch(KEGIATAN_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan = res_data;
                //   console.log(res_data);
            });
    },    

        getKegiatan6: function() {
        fetch(KEGIATAN_URL + "get6", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan6 = res_data;
                //   console.log(res_data);
            });
    },     

    limit_desk_kegiatan : function(text){
    return text.substring(0, 100)
    }, 

	push_kegiatan : function(id){
		this.$router.push('/isi_kegiatan/'+id);
    },    

    to_facebook : function () {
        window.open("http://www.facebook.com/sharer.php?u="+this.HOST, '_blank');
    },
    to_twitter : function(){
        // alert(this.HOST)
        window.open("https://twitter.com/share?url="+this.HOST+"&amp;text="+this.judul, '_blank');
    },







    // ================== PAGINASI ====================
        alertku: function(type, title) {
        this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
        });
        },

        btn_prev: function() {
        if (this.page_first > 1) {
            this.page_first--;
        } else {
            this.page_first = 1;
        }
        this.getView();
        },

        btn_next: function() {
        if (this.page_first >= this.page_last) {
            this.page_first == this.page_last;
        } else {
            this.page_first++;
        }
        this.getView();
        },

        cari_data: function() {
          this.getView();
        },
        onFileSelected : function(event){
            this.foto = event.target.files[0];
            console.log(this.foto);
        },
        convert_tgl : function(dateString){
			var date = new Date(dateString);
			var bulan = "";

			if (date.getMonth() == 0) {bulan = 'januari';} 
			else if (date.getMonth() == 1) {bulan = 'Februari';}
			else if (date.getMonth() == 2) {bulan = 'Maret';}
			else if (date.getMonth() == 3) {bulan = 'April';}
			else if (date.getMonth() == 4) {bulan = 'Mei';}
			else if (date.getMonth() == 5) {bulan = 'Juni';}
			else if (date.getMonth() == 6) {bulan = 'Juli';}
			else if (date.getMonth() == 7) {bulan = 'Agustus';}
			else if (date.getMonth() == 8) {bulan = 'September';}
			else if (date.getMonth() == 9) {bulan = 'Oktober';}
			else if (date.getMonth() == 10) {bulan = 'November';}
			else if (date.getMonth() == 11) {bulan = 'Desember';}
			else{bulan = ''}

          return date.getDate()+" "+bulan+" "+date.getFullYear();
        },
    // ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
    this.getView();
    this.getKegiatan();
	this.getKegiatan6();
  },

};



</script>

